import Input from '@/components/Input/Input';
import { HStack } from '@/components/Layout';
import { ControlledSelect } from '@/components/Select/ControlledSelect';
import { CFormItemBase, type CFormItemProps, buildCFormItem } from '../CFormItem';
type Option = {
  value: string;
  label: string;
};
type Props = CFormItemProps & {
  value?: {
    value?: number;
    unitCode?: string;
  };
  onChange: (value?: {
    value?: number;
    unitCode?: string;
  }) => void;
  options?: Option[];
  inputClassName?: string;
  isInt?: boolean;
  allowNegative?: boolean;
};

/**
 * Card-based Form / NumberWithUnitItem
 */
export const CFormNumberWithUnitItem = buildCFormItem((props: Props) => {
  return <CFormItemBase {...props} readComponent={<HStack className="gap-2 items-baseline">
          {props.value?.value}
          {props.options?.find(option => option.value === props.value?.unitCode)?.label}
        </HStack>} writeComponent={<HStack className="gap-2 items-center">
          <Input type="number" inputMode="numeric" pattern={props.isInt ? '[0-9]*' : undefined} min={props.allowNegative ? undefined : 0} step={props.isInt ? 1 : undefined} value={props.value?.value ?? ''} onChange={e => {
      const value = e.target.value === '' ? undefined : props.isInt ? parseInt(e.target.value, 10) : parseFloat(e.target.value);
      props.onChange({
        value: value,
        unitCode: props.value?.unitCode
      });
    }} className={props.inputClassName ?? 'w-[100px]'} disabled={props.readonly} />
          <ControlledSelect id={props.id} value={props.value?.unitCode ?? ''} onChange={option => props.onChange({
      value: props.value?.value,
      unitCode: option?.value
    })} fetchOptions={async () => props.options ?? []} hideSearch allowEmpty={!props.required} disabled={props.readonly} />
        </HStack>} />;
});